module.exports = __webpack_public_path__ + "static/pattern-washed_light.55d883ed.png";